import React, { useState, useEffect } from 'react';
import logo from '../assets/logo-w.png';

function Navigation({ activeSection, scrollToSection }) {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navItems = [
    { id: 'home', label: 'Home' },
    { id: 'services', label: 'Services' },
    { id: 'pricing', label: 'Pricing' },
    { id: 'about', label: 'About' },
    { id: 'contact', label: 'Contact' }
  ];

  return (
    <nav className={`navbar ${scrolled ? 'scrolled' : ''}`}>
      <div className="nav-wrapper">
        <div className="logo" onClick={() => scrollToSection('home')}>
          <img src={logo} alt="Techowdy LLC" className="logo-image" />
        </div>
        
        <button 
          className={`hamburger ${menuOpen ? 'active' : ''}`}
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle menu"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>

        <ul className={`nav-links ${menuOpen ? 'open' : ''}`}>
          {navItems.map(item => (
            <li key={item.id}>
              <a
                href={`#${item.id}`}
                className={`nav-link ${activeSection === item.id ? 'active' : ''}`}
                onClick={(e) => {
                  e.preventDefault();
                  scrollToSection(item.id);
                  setMenuOpen(false);
                }}
              >
                {item.label}
              </a>
            </li>
          ))}
          <li>
            <button 
              className="nav-cta"
              onClick={(e) => {
                e.preventDefault();
                scrollToSection('contact');
                setMenuOpen(false);
              }}
            >
              Get Started
            </button>
          </li>
        </ul>
      </div>
    </nav>
  );
}

export default Navigation;
